import { render, staticRenderFns } from "./DataSkpParent.vue?vue&type=template&id=283c3fbd&"
import script from "./DataSkpParent.vue?vue&type=script&lang=js&"
export * from "./DataSkpParent.vue?vue&type=script&lang=js&"
import style0 from "./DataSkpParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports